// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "rechargeable-heated-gloves",
  "entries": [
    {
      "id": "33373897818302",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-11.jpg?v=1783395826",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 11"
    },
    {
      "id": "33373897490622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-01.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 01"
    },
    {
      "id": "33373897523390",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-02.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 02"
    },
    {
      "id": "33373897556158",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-03.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 03"
    },
    {
      "id": "33373897588926",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-04.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 04"
    },
    {
      "id": "33373897621694",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-05.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 05"
    },
    {
      "id": "33373897654462",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-06.jpg?v=1783395826",
      "alt": "color:Red | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 06"
    },
    {
      "id": "33373897687230",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-07.jpg?v=1783395827",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 07"
    },
    {
      "id": "33373897719998",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-08.jpg?v=1783395826",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 08"
    },
    {
      "id": "33373897752766",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-09.jpg?v=1783395826",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 09"
    },
    {
      "id": "33373897785534",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-10.jpg?v=1783395826",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 10"
    },
    {
      "id": "33373897851070",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/spw3-heated-red-white-gallery-12.jpg?v=1783395826",
      "alt": "color:White | Seibertron Rechargeable Heated Gloves waterproof windproof heated gloves for winter outdoor use image 12"
    }
  ],
  "variants": [
    {
      "id": "44660441350334",
      "title": "Red / 2XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "2XS"
        }
      ],
      "values": [
        "Red",
        "2XS"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441383102",
      "title": "Red / XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "XS"
        }
      ],
      "values": [
        "Red",
        "XS"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441415870",
      "title": "Red / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "S"
        }
      ],
      "values": [
        "Red",
        "S"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441448638",
      "title": "Red / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "M"
        }
      ],
      "values": [
        "Red",
        "M"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441481406",
      "title": "Red / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "L"
        }
      ],
      "values": [
        "Red",
        "L"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441514174",
      "title": "Red / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "XL"
        }
      ],
      "values": [
        "Red",
        "XL"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660441546942",
      "title": "Red / 2XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Accessory size",
          "value": "2XL"
        }
      ],
      "values": [
        "Red",
        "2XL"
      ],
      "mediaId": "33373897490622"
    },
    {
      "id": "44660442792126",
      "title": "White / 2XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "2XS"
        }
      ],
      "values": [
        "White",
        "2XS"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442824894",
      "title": "White / XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "XS"
        }
      ],
      "values": [
        "White",
        "XS"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442857662",
      "title": "White / S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "S"
        }
      ],
      "values": [
        "White",
        "S"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442890430",
      "title": "White / M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "M"
        }
      ],
      "values": [
        "White",
        "M"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442923198",
      "title": "White / L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "L"
        }
      ],
      "values": [
        "White",
        "L"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442955966",
      "title": "White / XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "XL"
        }
      ],
      "values": [
        "White",
        "XL"
      ],
      "mediaId": "33373897687230"
    },
    {
      "id": "44660442988734",
      "title": "White / 2XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Accessory size",
          "value": "2XL"
        }
      ],
      "values": [
        "White",
        "2XL"
      ],
      "mediaId": "33373897687230"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
